import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { useRouter } from 'hooks/useRouter'
// constants
import { PUBLIC_PERMISSIONS } from 'constants/security'
// context
import { PublicContext } from 'containers/Risks/Risk/Edit/public'
// hooks
import { useParentRiskId } from 'hooks/risks/useParentRiskId'
// types
import { RootState } from 'store/store'
import { IRisk, ISecurityProfilePermissions } from 'types/graphql'

export const useRiskPermissions = (risk: IRisk): ISecurityProfilePermissions => {
  const router = useRouter()
  const isPublic = React.useContext(PublicContext)

  // The parent's set is read straight from the store instead of through useRiskRelatedForms: one
  // caller is RiskPageAPI itself, which runs above its own provider, so RiskAPIContext is empty
  // there. The record passed in as an argument is the reliable source.
  const parentRiskId = useParentRiskId(risk)

  const parentForms = useSelector((state: RootState) => state.relatedForms[parentRiskId] || [])

  if (isPublic) {
    return PUBLIC_PERMISSIONS
  }

  // Permissions come from the parent's set only when this record actually belongs to it — that is,
  // when it was created as a related form. A linked form keeps its own.
  const parentRelatedForm = parentForms.find(({ riskTemplateId }) => riskTemplateId === router.query.templateId)

  return parentRelatedForm?.permissions || risk?.permissions || ({} as ISecurityProfilePermissions)
}
